var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(Number.isNaN(_vm.averageEnergy))?_c('div',[_vm._v("\n      No calories reported in last 30 days\n    ")]):_c('div',[_c('strong',[_vm._v(" "+_vm._s(_vm.averageEnergy)+" cal/per day ")]),_vm._v(" in the last 30 days\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }